import { render, staticRenderFns } from "./AddCustomerFormModal.vue?vue&type=template&id=5da9ad44&"
import script from "./AddCustomerFormModal.vue?vue&type=script&lang=ts&"
export * from "./AddCustomerFormModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports